import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Compass } from "lucide-react";
import { apiJson } from "@/lib/api";

interface Priority { axe: string; urgence: string; impact_eur: number; titre: string; pourquoi: string; action: string; source: string }

const AXE: Record<string, { label: string; route: string }> = {
  cash: { label: "Cash", route: "/portage-clients" },
  clients: { label: "Clients", route: "/ventes" },
  contrats: { label: "Contrats", route: "/portage-clients" },
  financement: { label: "Financement", route: "/financement" },
  "données": { label: "Données", route: "/tresorerie" },
  "démarrage": { label: "Démarrage", route: "/mon-plan" },
  objectif: { label: "Objectif", route: "/mon-plan" },
};
const eur = (v: number) => `${Math.round(v).toLocaleString("fr-FR")} €`;

export default function PrioritiesPanel() {
  const [items, setItems] = useState<Priority[] | null>(null);
  const [all, setAll] = useState<Priority[]>([]);
  const [more, setMore] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    apiJson<{ top: Priority[]; items: Priority[] }>("/api/brain/priorites").then((r) => { setItems(r.top); setAll(r.items); }).catch(() => setItems([]));
  }, []);

  if (items === null) return null;
  if (items.length === 0) return null;
  const shown = more ? all : items;

  return (
    <Card className="border-primary/30" data-testid="priorities-panel">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2"><Compass className="h-4 w-4 text-primary" />Vos priorités du jour</CardTitle>
        <CardDescription>Calculées sur vos données réelles : cash, clients, contrats, financement. Vous décidez, Grafton propose.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {shown.map((p, i) => (
          <button key={i} onClick={() => navigate(AXE[p.axe]?.route || "/dashboard")} className="w-full text-left rounded-lg border border-border bg-secondary/30 p-3 hover:border-primary/40 transition-colors">
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm font-medium text-foreground">{i + 1}. {p.titre}</p>
              <div className="flex shrink-0 gap-1.5">
                <Badge variant="outline" className="text-[10px]">{AXE[p.axe]?.label || p.axe}</Badge>
                {p.urgence === "haute" && <Badge variant="outline" className="text-[10px] border-destructive/40 text-destructive">Urgent</Badge>}
              </div>
            </div>
            <p className="text-xs text-muted-foreground mt-1">{p.pourquoi}</p>
            <p className="text-xs mt-1"><span className="text-primary">→ </span>{p.action}{p.impact_eur > 0 ? ` (enjeu ${eur(p.impact_eur)})` : ""}</p>
          </button>
        ))}
        {all.length > items.length && (
          <button onClick={() => setMore(!more)} className="text-xs text-primary hover:underline">{more ? "Voir moins" : `Voir les ${all.length - items.length} autres points`}</button>
        )}
      </CardContent>
    </Card>
  );
}
